import { FunctionComponent } from 'react';
import styles from '../styles.module.scss';
import { PersonWalkingRegularIcon } from '../../Icons/PersonWalkingRegularIcon';
import { CameraWebRegularIcon } from '../../Icons/CameraWebRegularIcon';
import { LaptopRegularIcon } from '../../Icons/LaptopRegularIcon';
import HouseLaptopRegularIcon from '../../Icons/HouseLaptopRegularIcon';
import {
    PublicCourse,
    PublicOnRequestCourse,
    PublicOccurrence,
    PublicClassCourse,
} from '@cademy-package/sdk-component-types';

const InPersonDelivery: FunctionComponent = () => {
    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <PersonWalkingRegularIcon />
            </span>
            <p>Delivered In-Person</p>
        </li>
    );
};

const OnlineDelivery: FunctionComponent = () => {
    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <CameraWebRegularIcon />
            </span>
            <p>Delivered Online</p>
        </li>
    );
};

const InPersonOrOnlineDelivery: FunctionComponent = () => {
    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <HouseLaptopRegularIcon />
            </span>
            <p>Delivered Online or In-Person</p>
        </li>
    );
};

const OnDemandDelivery: FunctionComponent<{ course: PublicCourse }> = ({ course }) => {
    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <LaptopRegularIcon />
            </span>
            <p>On-Demand {course.keyword || 'course'}</p>
        </li>
    );
};

const OnRequestDeliveryHighlight: FunctionComponent<{ course: PublicOnRequestCourse }> = ({
    course,
}) => {
    if (course.available_for_in_person_delivery && course.available_for_online_delivery) {
        return <InPersonOrOnlineDelivery />;
    }
    if (course.available_for_in_person_delivery) {
        return <InPersonDelivery />;
    }
    if (course.available_for_online_delivery) {
        return <OnlineDelivery />;
    }
    return null;
};

const combinedCourseAndOccurrencesDelivery = (
    course: PublicClassCourse,
    occurrences?: PublicOccurrence[] | null
) => {
    if (occurrences && occurrences.length > 0) {
        const propertyValues = occurrences
            .map((occurrence) => occurrence.delivery)
            .filter((value) => value);
        if (propertyValues.length) {
            return Array.from(new Set(propertyValues));
        }
    }
    return [course.delivery];
};

export const DeliveryMethodHighlight: FunctionComponent<{
    course: PublicCourse;
    occurrences: PublicOccurrence[] | null;
}> = ({ course, occurrences }) => {
    if (course.type === 'on-request') {
        return <OnRequestDeliveryHighlight course={course} />;
    }
    if (course.type === 'on-demand') {
        return <OnDemandDelivery course={course} />;
    }

    const combinedDelivery = combinedCourseAndOccurrencesDelivery(
        course as PublicClassCourse,
        occurrences
    );

    if (combinedDelivery.length === 1 && combinedDelivery[0] === 'in-person') {
        return <InPersonDelivery />;
    }
    if (combinedDelivery.length === 1 && combinedDelivery[0] === 'online') {
        return <OnlineDelivery />;
    }
    if (combinedDelivery.length > 1 || combinedDelivery.includes('hybrid')) {
        return <InPersonOrOnlineDelivery />;
    }
    return null;
};
